import Header from "../Header";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../auth/LoginPage";
import SignPage from "../auth/SignPage";
import CompanyDetail from "./CompanyDetail";
import ContactDetail from "./ContactDetail";
import BlogDetail from "./BlogDetail";
import ResultDetail from "./ResultDetail";
import React from "react";
import CreateHouse from "./CreateHouse";
import HouseDetail from "./HouseDetail";
import HouseUpdate from "./HouseUpdate";
import ProfileDetail from "./ProfileDetail";
import ResetPage from "../auth/ResetPage";
import ChangeDetail from "./ChangeDetail";

const PageDetails = () => {

    return (
        <Routes>
            <Route element={<Header />}>
                <Route path="/result/" element={<ResultDetail />} />
                <Route path="/profile" element={<ProfileDetail />} />
                <Route path="/change" element={<ChangeDetail />} />
                <Route path="/login/" element={<LoginPage />} />
                <Route path="/sign/" element={<SignPage />} />
                <Route path="/reset/" element={<ResetPage />} />
                <Route path={'/about/:id'} element={<CompanyDetail />} />
                <Route path={'/contact/'} element={<ContactDetail />} />
                <Route path={'/blog/'} element={<BlogDetail />} />
                <Route path={'/create/'} element={<CreateHouse />} />
                <Route path={'/house/:id'} element={<HouseDetail/>} />
                <Route path={'/update/:id'} element={<HouseUpdate />} />
            </Route>
        </Routes>
    );
};

export default PageDetails;